/* eslint-disable @next/next/no-img-element */

import styles from "./styles.module.scss";

const CobasiCuida = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.descriptionContainer}>
        <img
          src="/inst/img/cobasi-cuida-mundo.svg"
          alt="Logo da Cobasi Cuida"
        />
        <div className={styles.description}>
          Transformando a vida dos <br />
          animais há mais de 25 anos.
          <a className="link link-orange" href="#">
            Saiba mais
          </a>
        </div>
      </div>

      <div className={styles.boxesContainer}>
        <div className={styles.boxContent}>
          <p className="body-text-sm">
            mais de
            <br />
            <span className="subtitle-lg">160 mil</span> <br />
            de animais amparados
          </p>
        </div>
        <div className={styles.boxContent}>
          <p className="body-text-sm">
            mais de <br />
            <span className="subtitle-lg">7,2 milhões</span>
            <br />
            de refeições doadas
          </p>
        </div>
        <div className={styles.boxContent}>
          <p className="body-text-sm">
            mais de <br />
            <span className="subtitle-lg">185 Ongs</span> <br />
            apoiadas em todo o Brasil
          </p>
        </div>
      </div>

      <img
        className={styles.illustration}
        src="/inst/img/illustration-cobasi-cuida.svg"
        alt="Ilustração Cobasi Cuida"
      />
    </div>
  );
};

export default CobasiCuida;
